
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/locations",
      function () {
        return require("private-next-pages/locations.tsx");
      }
    ]);
  